import { createFileRoute } from '@tanstack/react-router'

import { CustomerPageWrapper } from '@/components/molecules/customer-page-wrapper'
import PageHeader from '@/components/molecules/shared/page-header'
import { AccountingTransactions } from '@/features/accounting/pages/transactions'
import Head from '@/lib/navigation/head'

function TransactionsRoute() {
  return (
    <>
      <Head>
        <title>Transactions | Nonresident Tax</title>
      </Head>
      <CustomerPageWrapper stickyHeader={<PageHeader title="Transactions" sticky />}>
        <AccountingTransactions />
      </CustomerPageWrapper>
    </>
  )
}

export const Route = createFileRoute('/_shell/accounting/transactions')({
  component: TransactionsRoute,
})
